import sagas from './sagas';
import reducers from './reducers';

export default { sagas, reducers };
